import { createEntityAdapter, EntityAdapter } from '@ngrx/entity';
import { createReducer, on } from '@ngrx/store';
import { PageableModel, VentilationParameter } from '@mona/models';
import { EncountersActions } from '@mona/pdms/data-access-encounters';
import { EntriesInterval } from '@mona/shared/date';
import { VentilationParameterState, VentilationState } from '../../entities';
import { VentilationAction } from '../actions';

export const adapterVentilationParameter: EntityAdapter<VentilationParameter> =
    createEntityAdapter<VentilationParameter>({
        selectId: (item: VentilationParameter) => item.id,
    });

const ventilationParameterInit: VentilationParameterState = adapterVentilationParameter.getInitialState({
    startDate: null,
    pageableData: null,
});

export const initialState: VentilationState = {
    isLoading: false,
    interval: EntriesInterval.HOUR_1,
    parameters: ventilationParameterInit,
};

export const ventilationReducer = createReducer(
    initialState,
    on(VentilationAction.setIntervalAction, (state, action) => ({ ...state, interval: action.interval })),

    on(VentilationAction.setLoadingAction, (state, action) => ({ ...state, isLoading: action.isLoading })),

    // Ventilation Parameters

    on(VentilationAction.loadVentilationParameters, state => ({
        ...state,
        isLoading: true,
        parameters: { ...state.parameters },
    })),

    on(
        VentilationAction.loadVentilationParametersSuccess,
        VentilationAction.loadVentilationParametersFailed,
        state => ({
            ...state,
            isLoading: false,
            parameters: { ...state.parameters },
        }),
    ),

    on(VentilationAction.loadVentilationParametersSuccess, (state, action: PageableModel<VentilationParameter>) => {
        const { results, ...pageableData } = action;
        return {
            ...state,
            parameters: adapterVentilationParameter.upsertMany(results, {
                ...state.parameters,
                pageableData,
                startDate: results?.at(-1)?.date,
            }),
        };
    }),

    on(VentilationAction.upsertVentilationParameters, (state, { data }) => {
        return {
            ...state,
            isLoading: false,
            parameters: adapterVentilationParameter.upsertMany(data, { ...state.parameters }),
        };
    }),

    on(VentilationAction.addParameterChanges, (state, { toRemoveIds, toUpdateEntities }) => {
        const newState = adapterVentilationParameter.removeMany(toRemoveIds, { ...state.parameters });

        return {
            ...state,
            parameters: adapterVentilationParameter.upsertMany(toUpdateEntities, newState),
        };
    }),

    on(VentilationAction.removeVentilationParameters, (state, { ids }) => {
        return {
            ...state,
            isLoading: false,
            parameters: adapterVentilationParameter.removeMany(ids, { ...state.parameters }),
        };
    }),

    on(VentilationAction.clearVentilationData, EncountersActions.clearEncounter, () => initialState),
);
